import React from 'react';
import { withRouter, Link } from 'react-router';
import classNames from 'classnames';

@withRouter
export default class AdminTabs extends React.Component {
  getActiveTab = () => {
    const { router: { location: { pathname } } } = this.props;
    return pathname.substr(pathname.lastIndexOf('/') + 1);
  };

  render() {
    const { params: { organizationId } } = this.props;
    const activeTab = this.getActiveTab();
    const navItems = [
      {
        title: 'Billing',
        tabName: 'billing',
        url: `/admin/organization/${organizationId}/billing`,
      },
      {
        title: 'Subscriptions',
        tabName: organizationId,
        url: `/admin/organization/${organizationId}`,
      },
    ];

    const tabClasses = tabName => {
      return classNames({
        'nav-link': true,
        active: tabName === activeTab,
      });
    };

    return (
      <ul className="nav nav-pills clearfix" style={{ paddingBottom: 10 }}>
        {navItems.map(item => (
          <Link
            key={item.title}
            className={tabClasses(item.tabName)}
            to={item.url}
          >
            {item.title}
          </Link>
        ))}
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/OrganizationTabs.js